module.exports = __webpack_public_path__ + "static/img/documentation.7d408b8a.svg";